import { Box, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined'
import AdxButton from 'components/custom/AdxButton'

const RetakeTestModal = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const handleClose = () => {
    setIsModalOpen(false)
  }

  return (
    <React.Fragment>
      <Typography
        onClick={() => setIsModalOpen(true)}
        sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'alternate.main' }}
      >
        Retake test
      </Typography>
      <Modal
        open={isModalOpen}
        onClose={handleClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            width: '550px',
            backgroundColor: 'white.main',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '4.5px',
            padding: '32px',
            gap: '32px',
          }}
        >
          <Box
            sx={{
              width: '90px',
              height: '90px',
              backgroundColor: 'gray-background.main',
              borderRadius: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <DescriptionOutlinedIcon
              sx={{ height: '40px', width: '40px', color: 'alternate.main' }}
            />
          </Box>
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="h4" mb={'8px'}>
              Do you confirm retaking the Work Personality Test?
            </Typography>
            <Typography color={'light-gray-text.main'}>
              By clicking confirm, you will have to retake the Work Personality Test and the
              previous test will be overwritten.
            </Typography>
          </Box>
          <Box sx={{ width: '100%' }}>
            <AdxButton
              variant={'contained'}
              onClick={() =>
                navigate(`${pathname}/questions`, {
                  state: {
                    isRetake: true,
                  },
                })
              }
              sx={{ width: '100%', mb: '8px' }}
            >
              Retake test
            </AdxButton>
            <AdxButton variant={'ghost'} onClick={handleClose} sx={{ width: '100%' }}>
              Cancel
            </AdxButton>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default RetakeTestModal
